import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from '../constants';
import ApiService from '../modules/api-service';
import { SourceType, ValuationCountryCode } from '../modules/generated/api';

export const useCarDetail = (carId: string, source: SourceType, valuationCountry: ValuationCountryCode) =>
  useQuery([QueryKeys.carDetail, carId, source, valuationCountry], () =>
    ApiService.listCars.listCarsControllerDetail(source, carId, 2, valuationCountry).then((res) => res.data),
  );
